import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import Login from '../components/auth/Login';
import Dashboard from '../components/dashboard/Dashboard';
import CPRMDashboard from '../components/dashboard/CPRMDashboard';

import Layout from '../components/layout/Layout';
import SliderPage from '../components/SliderPage/SliderPage';

// Master components imports
import SystemMaster from '../components/master/systemmanager/SystemMaster';
import EquipmentMaster from '../components/master/Equipment/EquipmentMaster';
import CategoryMaster from '../components/master/category/CategoryMaster';
import DepartmentMaster from '../components/master/department/DepartmentMaster';
import ProjectMaster from '../components/master/project/ProjectMaster';
import TicketManagementSystem from '../components/ticketManagementSystem/TicketManagementSystem';
import ResourceMaster from '../components/pages/ResourceMaster';
import EquipmentActivity from "../components/master/Equipment/EquipmentActivity"

// Task Management component
import TaskManagement from '../components/master/TaskManagement'; // Import the TaskManagement component
import BlockManagement from '../components/master/block/BlockManagement';
import UnitManagement from '../components/master/unit/UnitManagement';
import DirectrateManagement from '../components/master/directrate/DirectrateManagement';
import MilestoneManagement from '../components/master/milestone/MilestoneManagement';
// Other page components
import Documents from '../components/Reports/ContractualTimelines';
import Milestones from '../components/pages/MileStones';
import FinanceManagement from '../components/pages/FinanceManagement';
// import UserManagement from '../components/pages/UserManagement';
import Compartment from '../components/master/compartment/Compartment';
import ReviewMeetings from '../components/pages/ReviewMeetings';
import ShipyardMaster from '../components/master/shipyard/ShipyardMaster';
import ActivityMaster from '../components/master/activityMaster/ActivityMaster';
import TaskTransactionPage from '../components/master/taskTransaction/TaskTransaction';
import ShipyardHolidayCalendar from '../components/holidayCalendar/HolidayCalendar';
import HelpandSupport from '../components/help&Support/HelpandSupport';
import HelpSupportWithLoader from '../components/help&Support/HelpSupportWithLoader'
import AccessPrivileges from '../components/accessPrivileges/AccessPrivileges';
import ModuleAccess from '../components/setup/moduleAccess/ModuleAccess';
import Privileges from '../components/setup/privilege/Privileges';
import UserManagement from '../components/setup/moduleAccess/UserManagement';
import ModularDraggableSections from '../components/DraggableSections/ModularDraggableSections';
import SortAnalysisChart from '../components/sortAnalysisChart/SortAnalysisChart';
import PERTChart from '../components/pertchart/PERTChart';
import UserProfile from '../components/pages/UserProfile';
import ChangePassword from '../components/pages/ChangePassword';
import Report from '../components/pages/Report';
import EquipmentTransaction from '../components/equipmentTransaction/EquipmentTransaction ';
import OutfittingData from '../components/outfittingData/OutfittingData ';
import SCurveData from '../components/sCurveData/SCurveData';
import SliderPageEquipment from '../components/master/Equipment/Equipmentslider';
import SliderPageCompartment from '../components/master/compartment/Compartmentslider';
import BlockTransaction from '../components/master/blockTransaction/BlockTransaction';
import UnitTransaction from '../components/master/unitTransaction/UnitTransaction';
import WOTDashboard from '../components/dashboard/WOTDashboard';
import PertUploadPage from '../components/pertupload/PertUploadPage';
import UserToProjectDashboard from '../components/dashboard/projectmappingdashboard/UserToProjectDashboard';
import PertConflictsResolve from '../components/dashboard/conflictsresolve/PertConflictsResolve';
import AssistanceWarshipSuperintendentDashboard from '../components/dashboard/assistancewarshipsuperintendentdashboard/AssistanceWarshipSuperintendentDashboard';
import SeniorNavalOverseerDashboard from '../components/dashboard/seniornavaloverseerdashboard/SeniorNavalOverseerDashboard';
import NavalOverseerDashboard from '../components/dashboard/navaloverseerdashboard/NavalOverSeerDashboard';
import InspectorsDashboard from '../components/dashboard/inspectorsdashboard/InspectorsDashboard';
import OfflineDashboard from '../components/dashboard/offlinedashboard/OfflineDashboard';
import NavalLegacyPage from '../components/dashboard/legacycomparison/LegacyComparison';
import SliderPageProject from '../components/master/project/ProjectSlider';

const ProtectedRoute = ({ children }) => {
  const authData = JSON.parse(localStorage.getItem('authData'));
  const accessToken = authData?.access;

  if (!accessToken) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }

      >
        <Route path='/' element={<Dashboard />} index />
        <Route path='/cprm-dashboard' element={<CPRMDashboard />} />
        <Route path='/wot-dashboard' element={<WOTDashboard />} />
        {/* Main navigation routes */}
        {/* <Route path="projects" element={<Projects />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="team" element={<Team />} />
        <Route path="messages" element={<Messages />} /> */}
        <Route path="ticket-management-system" element={<TicketManagementSystem />} />
        <Route path='holiday' element={<ShipyardHolidayCalendar/>} />
        <Route path='accessPrivileges' element={<AccessPrivileges/>} />
        {/* <Route path='draggable' element={<ModularDraggableSections/>} /> */}

        <Route path="slider" element={<ModularDraggableSections />} />
        <Route path="documents" element={<Documents />} />
        <Route path="milestones" element={<Milestones />} />
        <Route path="financemanagement" element={<FinanceManagement />} />
        <Route path="usermanagement" element={<UserManagement />} />
        <Route path="reviewmeetings" element={<ReviewMeetings />} />
        <Route path="help&support" element={<HelpSupportWithLoader />} />
        <Route path="sortanalysis" element={<SortAnalysisChart />} />
        <Route path="pertchart" element={<PERTChart />} />
        <Route path="equipment-transaction" element={<EquipmentTransaction />} />
        <Route path="outfitting-data" element={<OutfittingData />} />
        <Route path="usertoproject" element={<UserToProjectDashboard />} />
        <Route path="awpsdashboard" element= {<AssistanceWarshipSuperintendentDashboard />} />
        <Route path="snodashboard" element= {<SeniorNavalOverseerDashboard />} />
        <Route path="nodashboard" element= {<NavalOverseerDashboard />} />
        <Route path="insdashboard" element= {<InspectorsDashboard />} />
        <Route path="scurve-data" element={<SCurveData />} />
        <Route path="block-transaction" element={<BlockTransaction />} />
        <Route path="unit-transaction" element={<UnitTransaction />} />
        <Route path="pertupload" element={<PertUploadPage />} />
        <Route path="pertconflictsresolve" element={<PertConflictsResolve />} />
        <Route path="offlinedashboard" element={<OfflineDashboard />} />
        <Route path="/legacy-comparison" element={<NavalLegacyPage />} /> {/* Added Legacy Comparison route */}


        <Route path="resource-master" element={<ResourceMaster />} />



        {/* Masters routes */}
        <Route path="masters/system" element={<SystemMaster />} />
        <Route path="masters/equipment" element={<EquipmentMaster />} />
        <Route path="masters/equipmentactivity" element={<SliderPageEquipment />} />
        <Route path="masters/category" element={<CategoryMaster />} />
        <Route path="masters/department" element={<DepartmentMaster />} />
        <Route path="masters/project" element={<SliderPageProject />} />
        <Route path="masters/tasks" element={<TaskManagement />} /> {/* Add Task Management route */}
        <Route path="masters/compartment" element={<SliderPageCompartment />} />
        <Route path="masters/shipyard" element={<ShipyardMaster />} />
        <Route path="masters/block" element={<BlockManagement />} />
        <Route path="masters/directrate" element={<UnitManagement />} />
        <Route path="masters/unit" element={<DirectrateManagement />} />
        <Route path="masters/activity" element={<ActivityMaster />} />
        <Route path="masters/transaction" element={<TaskTransactionPage />} />
        <Route path="masters/milestone" element={<MilestoneManagement />} />


        <Route path="/setup/module-access" element={<ModuleAccess />} />
        <Route path="/setup/privileges" element={<Privileges />} />

        <Route path="profile" element={<UserProfile />} />
        <Route path="change-password" element={<ChangePassword />} />

        <Route path="/reports" element={<Report />} />

      </Route>

      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
};

export default AppRoutes;